<template>
    <card-sections :title="Lang.get('employerdashboard::pages/settings/index.title')" :subtitle="Lang.get('employerdashboard::pages/settings/index.subtitle')" :tabName="'general'" :hideMsg="true">

        <form @submit.prevent="submit">
            <div class="tab-pane fade show active" id="v-pills-home" role="tabpanel"
                 aria-labelledby="v-pills-home-tab">

                <flash-messages :hideErrors="true"></flash-messages>

                <p class="font-poppins font-weight-light color-dark-blue">
                    {{ Lang.get('employerdashboard::pages/settings/index.general.title') }}
                </p>
                <div class="form-row mt-3">
                    <div class="form-groupcol-md-6 col-lg-4">
                        <text-input v-model="form.title" :error="errors.title"
                                    :label="Lang.get('employerdashboard::shared.company')">
                        </text-input>
                    </div>
                    <div class="form-groupcol-md-6 col-lg-4">
                        <text-input v-model="form.company_registration_number"
                                    :error="errors.company_registration_number"
                                    :label="Lang.get('employerdashboard::shared.company_registration_number')">
                        </text-input>
                    </div>
                </div>
                <div class="form-row mt-3">
                    <div class="form-groupcol-md-6 col-lg-4">
                        <text-input v-model="form.street" :error="errors.street"
                                    :label="Lang.get('employerdashboard::shared.street')">
                        </text-input>
                    </div>
                    <div class="form-group col-md-3">
                        <text-input v-model="form.housenumber" :error="errors.housenumber"
                                    :label="Lang.get('employerdashboard::shared.house_number')">
                        </text-input>
                    </div>
                    <div class="form-group col-md-3">
                        <text-input v-model="form.housenumber_addition"
                                    :error="errors.housenumber_addition"
                                    :label="Lang.get('employerdashboard::shared.house_number_addition')">
                        </text-input>
                    </div>
                </div>
                <div class="form-row mt-3">
                    <div class="form-groupcol-md-6 col-lg-4">
                        <text-input v-model="form.phonenumber" :error="errors.phonenumber"
                                    :label="Lang.get('employerdashboard::shared.phone')">
                        </text-input>
                    </div>
                    <div class="form-group col-md-3">
                        <text-input v-model="form.zipcode" :error="errors.zipcode"
                                    :label="Lang.get('employerdashboard::shared.zipcode')">
                        </text-input>
                    </div>
                    <div class="form-group col-md-3">
                        <text-input v-model="form.city" :error="errors.city"
                                    :label="Lang.get('employerdashboard::shared.city')">
                        </text-input>
                    </div>
                </div>
                <div class="form-row mt-3">
                    <div class="form-group col-md-6 col-lg-4">
                        <text-input v-model="form.billing_email" :error="errors.billing_email"
                                    :label="Lang.get('employerdashboard::shared.billing_email')">
                        </text-input>
                    </div>
                    <div class="form-group col-md-6 col-lg-4">
                        <text-input
                            v-model="form.cost_center"
                            :error="errors.cost_center"
                            :placeholder="Lang.get('employerdashboard::shared.placeholder.cost_center')"
                            :label="Lang.get('employerdashboard::shared.cost_center')">
                        </text-input>
                    </div>
                </div>
                <div class="form-row mt-3">
                    <div class="form-group col-md-6 col-lg-4">
                        <text-input v-model="form.payroll_tax_number"
                                    :placeholder="Lang.get('employerdashboard::shared.placeholder.payroll_tax_number')"
                                    :error="errors.payroll_tax_number"
                                    :label="Lang.get('employerdashboard::shared.payroll_tax_number')">
                        </text-input>
                    </div>
                    <div class="form-group col-12 col-md-4">
                        <text-input
                            v-model="form.iban"
                            :error="errors.iban"
                            :placeholder="Lang.get('employerdashboard::shared.placeholder.iban')"
                            :label="Lang.get('employerdashboard::shared.iban')">
                        </text-input>
                    </div>
                    <div class="form-group col-12 col-md-4">
                        <text-input
                            v-model="form.bic"
                            :error="errors.bic"
                            :placeholder="Lang.get('employerdashboard::shared.placeholder.bic')"
                            :label="Lang.get('employerdashboard::shared.bic')">
                        </text-input>
                    </div>

                </div>
                <div class="form-row mt-3">
                    <div class="form-group col-12 col-md-4 col-lg-3">
                        <button
                            class="btn btn-primary font-poppins font-weight-bold btn-orange border-radius-19 px-4 mt-4">
                            {{ Lang.get('employerdashboard::pages/settings/index.save') }}
                        </button>
                    </div>
                </div>
            </div>
        </form>

    </card-sections>
</template>

<script>
import CardSections from "@/Pages/Settings/Shared/CardSections";
import TextInput from "@/Shared/TextInput";
import FlashMessages from "@/Shared/FlashMessages";

export default {
    metaInfo() {
        return {
            title: Lang.get('employerdashboard::pages/settings/index.title'),
        }
    },
    components: {
        CardSections,
        TextInput,
        FlashMessages,
    },
    props: {
        errors: Object,
        company: Object,
    },
    data() {
        return {
            form: {
                title: this.company.title,
                company_registration_number: this.company.company_registration_number,
                street: this.company.street,
                housenumber: this.company.housenumber,
                housenumber_addition: this.company.housenumber_addition,
                phonenumber: this.company.phonenumber,
                zipcode: this.company.zipcode,
                city: this.company.city,
                cost_center: this.company.cost_center,
                iban: this.company.iban,
                bic: this.company.bic,
                billing_email: this.company.billing_email,
                payroll_tax_number: this.company.payroll_tax_number,
            },
        }
    },
    methods: {
        url() {
            return location.href;
        },
        submit() {
            this.$inertia.put(this.route('nl.employerdashboard.settings.save', this.$page.props.auth.user.selected_company.uuid), this.form);
        },
    },
}
</script>
